<template>
  <div>
    <div class="breakout-rooms-here p-4">
      <div class="breakout-rooms-head">
        <!-- {{step}}-{{breakoutRooms.length}} -->
        <h4 v-if="step == 1">
          {{ roomId == "" ? "Create Breakout Room" : roomName + " - Edit" }}
        </h4>
        <h4 v-else>Breakout Rooms</h4>
        <v-btn
          v-if="isHostOrCoHost && breakoutRooms.length > 0 && step == 0"
          dark
          color="#0d6fec"
          @click="openCreateRoomDialog"
        >
          <v-icon color="#ffffff" size="18px">mdi-plus</v-icon> Add New
        </v-btn>
      </div>
      <div
        v-if="step == 0"
        class="mt-5"
        :class="{
          breakoutroom_create: breakoutRooms.length == 0,
          breakoutroom_listing: breakoutRooms.length > 0,
        }"
      >
        <div
          v-if="isLoading"
          class="blank-room d-flex align-items-center justify-content-center"
          style="min-height: 350px"
        >
          <v-progress-circular
            size="30"
            indeterminate
            color="primary"
          ></v-progress-circular>
        </div>
        <div
          v-else-if="breakoutRooms.length == 0 && !isLoading"
          class="blank-room"
        >
          <img src="../assets/Images/empty.png" class="mb-3" />
          <p>No breakout rooms have been created yet</p>
          <v-btn
            v-if="isHostOrCoHost"
            color="#0d6fec"
            class="create_room"
            @click="openCreateRoomDialog"
            >Create Breakout Room</v-btn
          >
        </div>
        <div v-else>
          <v-expansion-panels
            accordion
            multiple
            class="mb-3"
            v-model="expandedRooms"
          >
            <v-expansion-panel
              v-for="(room, i) in breakoutRooms"
              :key="i"
              :readonly="room.Members.length == 0"
              v-show="
                (isHostOrCoHost || room.IsPublished) &&
                (expandedRooms.length == 0 || expandedRooms[0] == i)
              "
            >
              <v-expansion-panel-header hide-actions>
                <div class="single-breakoutroom-head">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <h4 v-bind="attrs" v-on="on">{{ room.Name }}</h4>
                    </template>
                    <span>{{ room.Name }}</span>
                    <!-- <span>{{ room.Name }}-{{ room.Capacity }}/{{ room.Occupied }}</span> -->
                  </v-tooltip>
                  <div class="breakout-head-drop-right">
                    <div
                      class="breakout-attendee-count mr-2 d-flex justfy-content-center align-items-center"
                    >
                      <v-icon size="24px" color="#5a646e" class="mr-1"
                        >mdi-account-outline</v-icon
                      ><span
                        >{{ room.Members.length }}/{{ room.Capacity }}</span
                      >
                    </div>
                    <v-btn
                      v-if="isHostOrCoHost"
                      text
                      small
                      color="#0d6fec"
                      class="mr-2"
                      :class="{ 'd-none': !room.PreAssigned }"
                      :style="
                        !(room.IsPublished && room.Capacity > room.Occupied)
                          ? 'background-color:#a1b0c0 !important; color:#d7d9db !important;'
                          : ''
                      "
                      :disabled="
                        !(room.IsPublished && room.Capacity > room.Occupied)
                      "
                      @click.stop="openAssignAttendeeDialog()"
                      >Assign</v-btn
                    >
                    <v-btn
                      dark
                      small
                      color="#6cb649"
                      class="mr-2"
                      :class="{ 'd-none': room.PreAssigned }"
                      :style="
                        !room.IsPublished ||
                        room.Capacity <= room.Occupied ||
                        room.Capacity <= room.Members.length ||
                        room.RoomId == joinedRoomId
                          ? 'background-color:#a1b0c0 !important; color:#d7d9db !important;'
                          : ''
                      "
                      :disabled="
                        !room.IsPublished ||
                        room.Occupied >= room.Capacity ||
                        room.Members.length >= room.Capacity ||
                        room.RoomId == joinedRoomId
                      "
                      @click.stop="
                        openConfirmJoinDialog(room.RoomId, room.Name)
                      "
                      >{{
                        (room.Occupied >= room.Capacity ||
                          room.Members.length >= room.Capacity) &&
                        room.RoomId != joinedRoomId
                          ? "Room Full"
                          : "Join"
                      }}</v-btn
                    >
                    <div
                      v-if="isHostOrCoHost"
                      class="room-activate-switch mr-3"
                    >
                      <v-switch
                        v-model="room.IsPublished"
                        :loading="room.IsUpdating"
                        @click.stop="updateRoomStatus(room)"
                      ></v-switch>
                    </div>
                    <v-btn
                      v-if="isHostOrCoHost"
                      icon
                      small
                      class="mr-2"
                      :disabled="room.Members.length > 0"
                      @click.stop="
                        room.Members.length == 0
                          ? openEditRoomDialog(room)
                          : null
                      "
                      ><img
                        src="../assets/Images/self-service/edit-self.svg"
                        style="height: 18px; width: 18px"
                    /></v-btn>
                    <!-- <v-btn v-if="isHostOrCoHost" icon small @click.stop=""
                      ><v-icon size="18px" color="#5a646e"
                        >mdi-close</v-icon
                      ></v-btn
                    > -->
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-if="isHostOrCoHost"
                          icon
                          small
                          v-bind="attrs"
                          v-on="on"
                          disabled
                          @click.stop=""
                        >
                          <!-- <v-icon size="18px" color="#5a646e">mdi-close</v-icon> -->
                          <img
                            src="../assets/Images/self-service/delete-self.svg"
                            style="opacity: 0.6"
                          />
                        </v-btn>
                      </template>
                      <span>Delete Room</span>
                    </v-tooltip>
                  </div>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content v-if="room.Members.length > 0">
                <div class="breakout_attendees_list">
                  <div
                    class="single-breakout-attendee d-flex justify-content-between align-items-center"
                    v-for="(item, j) in room.Members"
                    :key="j"
                    v-show="item.IsActive"
                  >
                    <div
                      v-if="item.IsActive"
                      class="d-flex justify-content-start align-items-center"
                    >
                      <div class="breakout-attendee-img">
                        <img
                          v-if="item.ProfilePictureURL"
                          :src="item.ProfilePictureURL"
                          @error="item.ProfilePictureURL = ''"
                        />
                        <span
                          v-else
                          style="font-size: 24px; font-weight: bold"
                          >{{ item.NameInitial }}</span
                        >
                      </div>
                      <div class="breakout-attendee-details">
                        <h6>{{ item.Name }}</h6>
                        <!-- <h6>Robert Clarke</h6> -->
                        <p>
                          {{
                            item.Company +
                            (item.Company && item.Designation ? ", " : "") +
                            item.Designation
                          }}
                        </p>
                        <!-- <p>{{ item.Designation }}</p> -->
                      </div>
                    </div>
                    <div v-if="item.IsActive && isHostOrCoHost">
                      <!-- <v-btn text plain style="text-transform: capitalize"
                        >Move</v-btn
                      > -->
                      <v-tooltip v-if="breakoutRooms.length > 1" bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            text
                            plain
                            v-bind="attrs"
                            v-on="on"
                            disabled
                            style="text-transform: capitalize"
                            >Move</v-btn
                          >
                        </template>
                        <span>Move to another Room</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn text v-bind="attrs" v-on="on" disabled
                            ><v-icon color="#f00" size="20px"
                              >mdi-close</v-icon
                            ></v-btn
                          >
                        </template>
                        <span>Remove from Room</span>
                      </v-tooltip>
                      <!-- <v-btn text
                        ><v-icon color="#f00" size="20px"
                          >mdi-close</v-icon
                        ></v-btn
                      > -->
                    </div>
                  </div>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </div>
      <div v-else-if="step == 1" class="startfrom_blank mt-5">
        <v-row class="my-0">
          <v-col cols="12" md="6" lg="6">
            <label>Room Title*</label>
            <input
              type="text"
              placeholder="Add Title"
              maxlength="50"
              v-model="roomName"
            />
          </v-col>
          <v-col cols="12" md="6" lg="6">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <label>Access</label>
                <div
                  v-bind="attrs"
                  v-on="on"
                  class="count-section"
                  style="border: 0px"
                >
                  <!-- <v-switch
                  v-model="IsPublished"
                ></v-switch> -->

                  <div class="access-switch">
                    <div class="custom-switch-field">
                      <input
                        type="radio"
                        id="radio-one"
                        name="switch-one"
                        :value="falseValue"
                        v-model="preAssigned"
                      />
                      <label for="radio-one"
                        ><v-icon color="#959595" size="20px">mdi-earth</v-icon>
                        Public</label
                      >
                      <input
                        type="radio"
                        id="radio-two"
                        name="switch-one"
                        :value="trueValue"
                        v-model="preAssigned"
                        disabled
                      />
                      <label for="radio-two" style="opacity: 0.6; cursor: text"
                        ><v-icon color="#959595" size="20px">mdi-lock</v-icon>
                        Private</label
                      >
                    </div>
                  </div>
                </div>
              </template>
              <span v-if="preAssigned"
                >Host will assign attendee to this Room</span
              >
              <span v-else>Everyone can join to this Room</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row class="my-0">
          <v-col cols="12" md="6" lg="6">
            <div class="guest_duration mt-4">
              <label>Maximum Guest(s)</label>
              <div class="count-section">
                <v-btn
                  icon
                  tile
                  class="count-btn"
                  @click="
                    roomCapacity > minCapacity
                      ? roomCapacity--
                      : (roomCapacity = roomCapacity)
                  "
                  ><v-icon color="#656565" size="20px">mdi-minus</v-icon></v-btn
                >
                <div class="text-box">{{ roomCapacity }}</div>
                <v-btn
                  icon
                  tile
                  class="count-btn"
                  @click="
                    roomCapacity < maxCapacity
                      ? roomCapacity++
                      : (roomCapacity = roomCapacity)
                  "
                  ><v-icon color="#656565" size="20px">mdi-plus</v-icon></v-btn
                >
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="6" lg="6">
            <div class="guest_duration mt-4 d-none">
              <label>Duration (in Minutes)</label>
              <div class="count-section">
                <v-btn
                  icon
                  tile
                  class="count-btn"
                  @click="
                    roomDuration > minDuration
                      ? roomDuration--
                      : (roomDuration = roomDuration)
                  "
                  ><v-icon color="#656565" size="20px">mdi-minus</v-icon></v-btn
                >
                <div class="text-box">{{ roomDuration }}</div>
                <v-btn
                  icon
                  tile
                  class="count-btn"
                  @click="
                    roomDuration < maxDuration
                      ? roomDuration++
                      : (roomDuration = roomDuration)
                  "
                  ><v-icon color="#656565" size="20px">mdi-plus</v-icon></v-btn
                >
              </div>
            </div>
          </v-col>
        </v-row>
        <div class="host-instruction-desc">
          <label>Instructions from Host</label>
          <textarea
            rows="6"
            cols="100"
            placeholder="Message"
            v-model="roomInstruction"
          ></textarea>
        </div>
        <div class="switches text-center mt-4">
          <v-btn
            depressed
            height="45px"
            width="130px"
            color="#e6e8ed"
            @click="step = 0"
            class="cancel-switch mr-3"
            >Cancel</v-btn
          >
          <v-btn
            dark
            height="45px"
            width="130px"
            color="#0d6fec"
            @click="createBreakoutRoom()"
            :loading="createRoomInProgress"
            class="create-switch"
            >{{ roomId == "" ? "Create" : "Update" }}</v-btn
          >
        </div>
      </div>
    </div>

    <!-- <div
      class="startfrom_blank p-4 pb-12"
      v-if="createBreakoutRoomDialog && false"
    >
      <h3>Create Breakout Rooms</h3>
      <label>Room Title</label>
      <input type="text" name="" id="" placeholder="Add Title" />
      <v-row class="my-0">
        <v-col cols="12" md="6" lg="6">
          <div class="guest_duration mt-4">
            <label>Maximum Guest(s)</label>
            <div class="count-section">
              <v-btn icon tile class="count-btn" @click="decrement1()"
                ><v-icon color="#656565" size="20px">mdi-minus</v-icon></v-btn
              >
              <div class="text-box">{{ roomCapacity }}</div>
              <v-btn icon tile class="count-btn" @click="increment1()"
                ><v-icon color="#656565" size="20px">mdi-plus</v-icon></v-btn
              >
            </div>
          </div>
        </v-col>
        <v-col cols="12" md="6" lg="6">
          <div class="guest_duration mt-4">
            <label>Duration of the Session in Minute</label>
            <div class="count-section">
              <v-btn icon tile class="count-btn" @click="decrement2()"
                ><v-icon color="#656565" size="20px">mdi-minus</v-icon></v-btn
              >
              <div class="text-box">{{ roomDuration }}</div>
              <v-btn icon tile class="count-btn" @click="increment2()"
                ><v-icon color="#656565" size="20px">mdi-plus</v-icon></v-btn
              >
            </div>
          </div>
        </v-col>
      </v-row>
      <div class="host-instruction-desc">
        <label>Instructions from Host</label>
        <textarea rows="12" cols="100" placeholder="Message"></textarea>
      </div>
      <div class="switches text-center mt-4">
        <v-btn
          depressed
          height="45px"
          width="130px"
          color="#e6e8ed"
          @click="
            createBreakoutRoomDialog = false;
            brekaOutRoomDialog = true;
          "
          class="cancel-switch mr-3"
          >Cancel</v-btn
        >
        <v-btn
          dark
          height="45px"
          width="130px"
          color="#0d6fec"
          @click="createBreakoutRoom()"
          class="create-switch"
          >Create</v-btn
        >
      </div>
    </div> -->

    <!-- <div v-if="false" class="breakout-rooms-here p-4">
      <div class="breakout-rooms-head">
        <h4>Breakout Rooms</h4>
        <v-btn dark color="#0d6fec"
          ><v-icon color="#ffffff" size="18px">mdi-plus</v-icon> Add New</v-btn
        >
      </div>
      <div class="breakoutroom_listing mt-5">
        <v-expansion-panels class="mb-3">
          <v-expansion-panel v-for="(item, i) in 4" :key="i">
            <v-expansion-panel-header hide-actions>
              <div class="single-breakoutroom-head">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <h4 v-bind="attrs" v-on="on">Breakout Room</h4>
                  </template>
                  <span>Breakout Room</span>
                </v-tooltip>
                <div class="breakout-head-drop-right">
                  <v-btn
                    text
                    small
                    color="#0d6fec"
                    class="mr-2"
                    @click="openAssignAttendeeDialog()"
                    >Assign</v-btn
                  >
                  <div
                    class="
                      breakout-attendee-count
                      mr-2
                      d-flex
                      justfy-content-center
                      align-items-center
                    "
                  >
                    <v-icon size="24px" color="#5a646e" class="mr-1"
                      >mdi-account-outline</v-icon
                    ><span>3</span>
                  </div>
                  <v-btn dark small color="#6cb649" class="mr-2">Join</v-btn>
                  <div class="room-activate-switch mr-3">
                    <v-switch v-model="switch1"></v-switch>
                  </div>
                  <v-btn icon small class="mr-2"
                    ><img
                      src="../assets/Images/self-service/edit-self.svg"
                      style="height: 18px; width: 18px"
                  /></v-btn>
                  <v-btn icon small
                    ><v-icon size="18px" color="#5a646e"
                      >mdi-close</v-icon
                    ></v-btn
                  >
                </div>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div class="breakout_attendees_list">
                <div
                  class="single-breakout-attendee"
                  v-for="(item, j) in 3"
                  :key="j"
                >
                  <div class="breakout-attendee-img">
                    <img src="../assets/Images/attendee.png" />
                  </div>
                  <div class="breakout-attendee-details">
                    <h6>Robert Clarke</h6>
                    <p>Director</p>
                    <p>MIT Industries</p>
                  </div>
                </div>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
    </div> -->

    <v-dialog
      persistent
      v-model="createBreakoutRoomSuccess"
      hide-overlay
      width="470px"
    >
      <v-card class="p-4">
        <div class="room-create-success-msg">
          <img src="../assets/Images/success-tick.svg" />
          <h5>The break out room has been created successfully!</h5>
          <v-btn
            dark
            width="180px"
            height="42px"
            color="#0d6fec"
            @click="createBreakoutRoomSuccess = false"
            class="success-acknowledge-btn"
            >Great</v-btn
          >
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="addAttendeeBreakoutRoom" hide-overlay width="416px">
      <v-card class="p-4">
        <div class="addattendee-breakoutroom-head">
          <h6>Assign Attendee</h6>
          <v-btn icon @click="addAttendeeBreakoutRoom = false"
            ><v-icon size="20px" color="#5a646e">mdi-close</v-icon></v-btn
          >
        </div>
        <div class="breakout-add-attendee-list">
          <div class="breakout-add-attendee-search">
            <input type="text" id="" placeholder="Search Attendees..." />
          </div>
          <div class="breakout-attendee-section">
            <div v-for="(item, k) in 50" :key="k" class="single-add-attendee">
              <v-checkbox v-model="checkbox" class="mr-3"></v-checkbox>
              <p>Richard C. Costello</p>
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="confirmJoinDialog" hide-overlay width="416px">
      <v-card class="p-4">
        <div class="addattendee-breakoutroom-head">
          <h6>
            Join <b>{{ roomName }}?</b>
          </h6>
          <!-- <v-btn icon @click="confirmJoinDialog = false"
            ><v-icon size="20px" color="#5a646e">mdi-close</v-icon></v-btn
          > -->
        </div>
        <center>
          <!-- <h5>Join {{roomName}}?</h5> -->
          <!-- <v-btn
            dark
            color="#0d6fec"
            @click="joinBreakoutRoom();"
            class="success-acknowledge-btn"
            >Cancel</v-btn
          >
          <v-btn
            color="#0d6fec"
            @click="joinBreakoutRoom();"
            class="success-acknowledge-btn"
            >Join</v-btn
          >
           -->
          <div class="p-4">
            <!-- color="#669c10" -->
            <v-btn
              dark
              color="#6cb649"
              @click="joinBreakoutRoom()"
              class="create-switch mr-3"
              >Join</v-btn
            >
            <v-btn
              depressed
              color="#e6e8ed"
              @click="confirmJoinDialog = false"
              class="cancel-switch"
              >Cancel</v-btn
            >
          </div>
        </center>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  props: {
    sessionTypeId: {
      type: Number,
      default: 0,
    },
    sessionId: {
      type: String,
      default: "",
    },
    tableId: {
      type: String,
      default: "",
    },
    isLoading: {
      type: Boolean,
      default: true,
    },
    breakoutRooms: {
      type: Array,
      default: () => [],
    },
    isHostOrCoHost: {
      type: Boolean,
      default: false,
    },
    joinedRoomId: {
      type: String,
      default: "",
    },
  },
  components: {},

  data() {
    return {
      step: 0,

      roomId: "",
      expandedRooms: [],
      minCapacity: 2,
      maxCapacity: 12,
      defaultCapacity: 8,
      roomCapacity: 0,
      minDuration: 2,
      maxDuration: 60,
      defaultDuration: 10,
      roomDuration: 0,
      roomName: "",
      roomInstruction: "",
      preAssigned: false,
      trueValue: true,
      falseValue: false,
      createRoomInProgress: false,

      createBreakoutRoomSuccess: false,
      switch1: true,
      addAttendeeBreakoutRoom: false,
      checkbox: true,
      confirmJoinDialog: false,
    };
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {},

  methods: {
    // decrement1() {
    //   if (this.roomCapacity > 2) {
    //     this.roomCapacity--;
    //   }
    // },

    // increment1() {
    //   if (this.roomCapacity < 8) {
    //     this.roomCapacity++;
    //   }
    // },

    // decrement2() {
    //   if (this.roomDuration > 2) {
    //     this.roomDuration--;
    //   }
    // },

    // increment2() {
    //   if (this.roomDuration < 60) {
    //     this.roomDuration++;
    //   }
    // },
    openCreateRoomDialog() {
      this.roomId = "";
      this.roomName = "Breakout " + (this.breakoutRooms.length + 1).toString();
      this.roomCapacity = this.defaultCapacity;
      this.roomDuration = this.defaultDuration;
      this.step = 1;
    },
    openEditRoomDialog(room) {
      this.roomId = room.RoomId;
      this.roomName = room.Name;
      this.preAssigned = room.PreAssigned;
      this.roomInstruction = room.Instruction;
      this.roomCapacity = room.Capacity;
      this.roomDuration = room.Duration;
      this.step = 1;
    },
    createBreakoutRoom() {
      this.roomName = this.roomName ? this.roomName.trim() : "";
      if (!this.roomName) {
        this.showSnackbar("Please enter Room Title", "error", "top");
        return;
      }
      this.createRoomInProgress = true;
      let room = {
        RoomId: this.roomId,
        Name: this.roomName,
        PreAssigned: this.preAssigned,
        Instruction: this.roomInstruction,
        Capacity: this.roomCapacity,
        Duration: this.roomDuration,
      };
      if (this.sessionTypeId == 3) {
        room.SessionId = this.sessionId;
      } else if (this.sessionTypeId == 4) {
        room.TableId = this.tableId;
      }
      this.$emit("createBreakoutRoom", room);
    },
    openAssignAttendeeDialog() {
      this.addAttendeeBreakoutRoom = true;
    },
    onCreateBreakoutRoomSuccess(roomId) {
      //alert("hurreh! "+id);
      //this.createBreakoutRoomSuccess = true;
      this.step = 0;
      this.createRoomInProgress = false;
      if (!roomId) {
        this.showSnackbar("New room created", "info", "top");
      } else {
        this.showSnackbar("Room update", "info", "top");
      }
    },
    onCreateBreakoutRoomError(error) {
      //alert(err);
      //this.createBreakoutRoomSuccess = true;
      //this.step = 0;
      this.createRoomInProgress = false;
      if (!this.roomId) {
        this.showSnackbar("Unable to create room", "error", "top");
      } else {
        this.showSnackbar("Unable to update room", "error", "top");
      }
      console.error("Error updating room status: ", error);
    },
    updateRoomStatus(room) {
      room.IsUpdating = true;
      //alert("openEditRoomDialog: "+room.IsPublished);
      this.$emit("updateRoomStatus", room);
    },
    onUpdateRoomStatusSuccess(roomId, name, isPublished) {
      //this.createBreakoutRoomSuccess = true;
      //this.step = 0;
      // var room = this.breakoutRooms.filter(function (item) {
      //   return item.RoomId == roomId;
      // });
      // if (room.length > 0) {
      //   room[0].IsUpdating = false;
      // }
      if (isPublished) {
        this.showSnackbar("The room is opened to join", "info", "top");
      } else {
        this.showSnackbar("The room is closed", "info", "top");
      }
    },
    onUpdateRoomStatusError(roomId, error) {
      this.createRoomInProgress = false;
      let room = this.breakoutRooms.filter(function (item) {
        if (item.RoomId == roomId) {
          return true;
        }
      });
      if (room.length > 0) {
        room[0].IsPublished = !room.IsPublished;
      }
      this.showSnackbar("Unable to change status", "error", "top");
      //this.createBreakoutRoomSuccess = true;
      //this.step = 0;

      console.error("Error updating room status: ", error);
    },
    openConfirmJoinDialog(roomId, roomName) {
      this.roomId = roomId;
      this.roomName = roomName;
      this.confirmJoinDialog = true;
    },
    joinBreakoutRoom() {
      this.confirmJoinDialog = false;
      this.$emit("joinBreakoutRoom", this.roomId, this.roomName);
    },
  },
};
</script>